import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { iconsCatalog } from 'src/app/pages/dashboards/models/widget-config';

@Component({
  selector: 'icon-selector',
  templateUrl: './icon-selector.component.html',
  styleUrls: ['./icon-selector.component.scss']
})
export class IconSelectorComponent {

  @Input() iconsList: string[] = iconsCatalog;
  @Input() selectedIcon: string | null = null;
  @Input() enableSearch: boolean = true;
  @Input() customHeight: string = '29px';
  @Output() selectedIconChange$ = new EventEmitter<string | null>();

  showIconOverlay: boolean = false;
  iconSearch = '';

  constructor(private eRef: ElementRef,
    private _translate: TranslateService
  ) {
    this._translate.setDefaultLang(localStorage.getItem('language') || 'en');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showIconOverlay && !this.eRef.nativeElement.contains(event.target)) {
      this.showIconOverlay = false;
    }
  }

  selectIcon(icon: string) {
    this.selectedIcon = icon;
    this.selectedIconChange$.emit(icon);
  }

  filteredIcons(): string[] {
    if (!this.iconSearch) return this.iconsList;
    return this.iconsList.filter(icon => icon.toLowerCase().includes(this.iconSearch.toLowerCase()));
  }

  removeSelectedIcon(event: MouseEvent) {
    event.stopPropagation();
    this.selectedIcon = null;
    this.selectedIconChange$.emit(null);
  }
}